import { loading } from './LoadingUtil';
import { convertNumberToCursor, convertCursorToNumber } from '../utils';
import { getCampaignCategoryList } from '../services/CampaignCategoryAPIHelper';
import { StatusTag } from '../config/CustomEnums';
import { createModel } from './BaseModel';
import { getListDisplayLastModifiedDate } from 'utils/TimeFormatUtil';


const getInitialState = () => ({
  listDisplayFields: [
    { displayName: 'ID', fieldName: 'pk', linked: true },
    { displayName: 'Name', fieldName: 'name', orderField: 'name', linked: false },
    {
      displayName: 'Display order',
      fieldName: 'order',
      orderField: 'displayPriority',
    },
    { displayName: 'Last modified time', fieldName: 'displayLastModifiedTime' },
    { displayName: 'Status', fieldName: 'status' },
  ],
  categoryList: [],
  totalCount: 0,
  totalPage: 0,
  pageInfo: {
    startCursor: 0,
    endCursor: 0,
  },
  checkedList: [],
});

export default createModel({
  namespace: 'campaignCategoryList',
  states: getInitialState(),
  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    assembleCategoryList(state, { payload }) {
      const categoryList = payload.categoryList.map(({ node }, index) => ({
        id: node.id,
        pk: node.pk,
        name: payload.nameContainsId ? `[ID:${node.pk}] ${node.name}` : node.name,
        order: node.displayPriority,
        isForcedInactive: node.isForcedInactive,
        status: node.isForcedInactive ? StatusTag.inactive : StatusTag.active,
        displayLastModifiedTime: getListDisplayLastModifiedDate(node?.lastModifiedDate),
      }));
      const pageInfo = payload.pageInfo;
      const startCursor = convertCursorToNumber(pageInfo.startCursor);
      const endCursor = convertCursorToNumber(pageInfo.endCursor);
      return {
        ...state,
        categoryList:
          payload.isSelectorLoad && payload.page > 1
            ? [...state.categoryList, ...categoryList]
            : categoryList,
        totalCount: payload.totalCount,
        totalPage: Math.ceil(payload.totalCount / 20),
        pageInfo: {
          startCursor: startCursor + 1,
          endCursor: endCursor + 1,
        },
      };
    },
  },
  params: {
    listAPI: getCampaignCategoryList,
    objectKey: 'campaignCategories',
    parse:(data)=>{
      return data.campaignCategories.edges.map(item=>item.node)
    },
  },
  effects: {
    getCampaignCategoryList: [
      function* ({ payload }, { put }) {
        const page = payload.page || 1;
        const pageSize = payload?.isAll ? 100 : 20;
        const pageCursor = page
          ? convertNumberToCursor((page - 1) * pageSize - 1)
          : '';
        const serviceArgs = [
          getCampaignCategoryList,
          pageCursor,
          payload,
        ];

        function* onSuccess(data) {
          const categories = data.campaignCategories;
          console.log(categories);
          yield put({
            type: 'assembleCategoryList',
            payload: {
              categoryList: categories.edges,
              totalCount: categories.totalCount,
              pageInfo: categories.pageInfo,
              ...payload,
            },
          });
        }
        yield loading(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
  },
});
